import { render } from "./StudyInUS.vue?vue&type=template&id=319ad600"
import script from "./StudyInUS.vue?vue&type=script&lang=js"
export * from "./StudyInUS.vue?vue&type=script&lang=js"

import "./StudyInUS.vue?vue&type=style&index=0&id=319ad600&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__